// Names come from the runtime's built-in Intl.DisplayNames — no data dependency,
// no react-intl at module load (safe for fym-shared / Next.js server routes).
export function getCountryName(code: string, locale = 'en'): string {
  try {
    const upperCode = code.toUpperCase();
    const display = new Intl.DisplayNames([locale], { type: 'region' });
    const name = display.of(upperCode);
    // Intl.DisplayNames returns "Unknown Region" for invalid codes; fall back to raw code instead
    if (name === 'Unknown Region') {
      return upperCode;
    }
    return name ?? upperCode;
  } catch {
    return code.toUpperCase();
  }
}
